<template>
  <Modal
    :id="id"
    :modalTitle="modalTitle"
    :class="classes + ' ' + subClass"
    :showFooter="showFooter"
    class="modalConfirmCancellation"
    :onClose="onClose"
  >
    <div v-if="content === 'content1'">
      <label class="generalLabel pt-1 pb-3"
        >Vas a modificar el estado del contrato a Cancelado SIN revisión. Debes
        tener confirmación de la cancelación del plan de pagos si procede y de
        la cancelación de la entrega/envío del terminal si procede antes de
        confirmar la cancelación. Eres el responsable que el procedimiento se
        complete sin incidencias</label
      >
      <label class="generalLabel pt-1" for="reason">Selecciona un motivo</label>
      <div class="row">
        <div class="col-12 col-lg-6 mb-4">
          <VueNextSelect
            class="form-control generalInput"
            id="reason"
            :options="reasonsData"
            v-model.trim="reason"
            close-on-select
            placeholder=""
            aria-labelledby="Motivo"
          >
          </VueNextSelect>
        </div>
      </div>
      <div
        class="custom-control custom-checkbox"
        v-if="
          reasonRevision.indexOf(reason) !== -1 &&
          !$store.state.roles.Backoffice_member_empresas
        "
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="revision"
          v-model.trim="revision"
        />
        <label class="custom-control-label" for="revision">Con revisión</label>
      </div>
      <div
        class="custom-control custom-checkbox"
        v-if="
          reasonSecura.indexOf(reason) !== -1 &&
          !$store.state.roles.Backoffice_member_empresas
        "
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="sequra"
          v-model.trim="sequra"
        />
        <label class="custom-control-label" for="sequra">Origen SEQURA</label>
      </div>
    </div>
    <div
      v-if="
        revision &&
        content === 'content2' &&
        (loadingDataCustomer || loadingDataContract)
      "
      class="h-100 d-flex justify-content-center align-items-center"
      style="min-height: 250px"
    >
      <img src="../../../../../assets/loaderPrimary.svg" height="50" alt="" />
    </div>
    <div
      v-if="
        revision &&
        content === 'content2' &&
        !loadingDataCustomer &&
        !loadingDataContract
      "
    >
      <div class="row">
        <div class="col-12">
          <h3 class="generalSubtitle">Datos Cliente</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-3 mb-4">
          <div class="generalTitleItemModal">Nombre</div>
          <div>{{ name || "-" }}</div>
        </div>
        <div class="col-12 col-lg-3 mb-4">
          <div class="generalTitleItemModal">Apellidos</div>
          <div>{{ surname1 || "-" }}</div>
        </div>
        <div class="col-12 col-lg-3 mb-4">
          <div class="generalTitleItemModal">Tipo de doc</div>
          <div>{{ documentType || "-" }}</div>
        </div>
        <div class="col-8 col-lg-3 mb-4">
          <div class="generalTitleItemModal">Numero de doc</div>
          <div>{{ documentNumber || "-" }}</div>
        </div>
        <div class="col-12 col-lg-3 mt-4">
          <div class="generalTitleItemModal">Fecha de nacimiento</div>
          <div>{{ $dateBackToFront(birthdate) }}</div>
        </div>
        <div class="col-12 col-lg-3 mt-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="mobile"> Teléfono</label>
            <input
              type="text"
              class="form-control generalInput"
              id="mobile"
              maxlength="11"
              v-model.trim.lazy="v$.mobile.$model"
            />
            <div v-if="v$.mobile.$dirty">
              <small
                class="form-text text-danger"
                v-if="v$.mobile.required.$invalid"
                >Campo requerido</small
              >
              <small
                class="form-text text-danger"
                v-if="v$.mobile.numeric.$invalid"
                >El formato no es correcto</small
              >
              <small
                class="form-text text-danger"
                v-if="v$.mobile.minLength.$invalid"
                >La longitud no es correcta</small
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-5 mt-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="email">Email</label>
            <input
              type="text"
              class="form-control generalInput"
              id="email"
              v-model.trim.lazy="v$.email.$model"
              autocomplete="off"
            />
            <div v-if="v$.email.$dirty">
              <small
                class="form-text text-danger"
                v-if="v$.email.required.$invalid"
                >Campo requerido</small
              >
              <small
                class="form-text text-danger"
                v-if="v$.email.email.$invalid && !v$.email.required.$invalid"
                >El formato no es correcto</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h3 class="generalSubtitle">Dirección</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-4 col-lg-2">
          <div class="form-group">
            <label class="generalTitleItemModal" for="streetType">
              Tipo de Vía</label
            >
            <VueNextSelect
              class="form-control generalInput"
              id="streetType"
              :options="tipoDireccion"
              v-model.trim.lazy="v$.streetType.$model"
              placeholder=""
              close-on-select
            ></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
            <div v-if="v$.streetType.$dirty">
              <small
                class="form-text text-danger"
                v-if="v$.streetType.required.$invalid"
                >Campo requerido</small
              >
            </div>
          </div>
        </div>
        <div class="col-8 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="street">
              Nombre de la vía</label
            >
            <input
              type="text"
              class="form-control generalInput"
              id="street"
              v-model.trim.lazy="v$.street.$model"
            />
            <div v-if="v$.street.$dirty">
              <small
                class="form-text text-danger"
                v-if="v$.street.required.$invalid"
                >Campo requerido</small
              >
              <small
                class="form-text text-danger"
                v-if="
                  v$.street.addressCaracters.$invalid &&
                  !v$.street.required.$invalid
                "
                >Formato invalido</small
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="row">
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="number">Número</label>
                <input
                  type="text"
                  class="form-control generalInput"
                  id="number"
                  v-model.trim.lazy="v$.number.$model"
                />
                <div v-if="v$.number.$dirty">
                  <small
                    class="form-text text-danger"
                    v-if="v$.number.required.$invalid"
                    >Campo requerido</small
                  >
                  <small
                    class="form-text text-danger"
                    v-if="
                      v$.number.addressCaracters.$invalid &&
                      !v$.number.required.$invalid
                    "
                    >Formato invalido</small
                  >
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="floor">Piso</label>
                <input
                  type="text"
                  class="form-control generalInput"
                  id="floor"
                  v-model.trim.lazy="v$.floor.$model"
                />
                <div v-if="v$.floor.$dirty">
                  <small
                    class="form-text text-danger"
                    v-if="v$.floor.addressCaracters.$invalid"
                    >Formato invalido</small
                  >
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="door">Puerta</label>
                <input
                  type="text"
                  class="form-control generalInput"
                  id="door"
                  v-model.trim.lazy="v$.door.$model"
                />
                <div v-if="v$.door.$dirty">
                  <small
                    class="form-text text-danger"
                    v-if="v$.door.addressCaracters.$invalid"
                    >Formato invalido</small
                  >
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="stair"
                  >Escalera</label
                >
                <input
                  type="text"
                  class="form-control generalInput"
                  id="stair"
                  v-model.trim.lazy="v$.stair.$model"
                />
                <div v-if="v$.stair.$dirty">
                  <small
                    class="form-text text-danger"
                    v-if="v$.stair.addressCaracters.$invalid"
                    >Formato invalido</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="city"> Localidad</label>
            <input
              type="text"
              class="form-control generalInput"
              id="city"
              v-model.trim.lazy="v$.city.$model"
            />
            <div v-if="v$.city.$dirty">
              <small
                class="form-text text-danger"
                v-if="v$.city.required.$invalid"
                >Campo requerido</small
              >
              <small
                class="form-text text-danger"
                v-if="
                  v$.city.addressCaracters.$invalid &&
                  !v$.city.required.$invalid
                "
                >Formato invalido</small
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="state"> Provincia</label>
            <VueNextSelect
              class="form-control generalInput"
              id="state"
              :options="provincesData"
              v-model.trim.lazy="v$.state.$model"
              placeholder=""
              close-on-select
            ></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
            <div v-if="v$.state.$dirty">
              <small
                class="form-text text-danger"
                v-if="v$.state.required.$invalid"
                >Campo requerido</small
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="postalCode">
              Código Postal</label
            >
            <input
              type="text"
              class="form-control generalInput"
              id="postalCode"
              v-model.trim.lazy="v$.postalCode.$model"
            />
            <div v-if="v$.postalCode.$dirty">
              <small
                class="form-text text-danger"
                v-if="v$.postalCode.required.$invalid"
                >Campo requerido</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="h-100 d-flex justify-content-between mt-5">
        <div>
          <button
            class="btn generalSecondaryButton"
            @click="selectTab('content1')"
          >
            Atrás
          </button>
        </div>
        <div>
          <button
            class="btn btn-primary generalPrimaryButton"
            @click="selectTab('content3')"
            :disabled="v$.$invalid"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
    <div v-if="content === 'content3'">
      <div class="row">
        <div class="col-12">
          <h3 class="generalSubtitle">Costes</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12">
          Pagos pendientes: {{ dataCancellation.amountPendingPay }}€.
        </div>
        <div class="col-12 col-lg-12">
          En caso de mal estado de un terminal:
          {{ dataCancellation.amountDefectiveTerminal }}€.
        </div>
        <div class="col-12 col-lg-12">
          Total en caso de que se devuelva un terminal en mal estado:
          {{ dataCancellation.amountTotal }}€.
        </div>
        <div class="col-12 col-lg-12">
          Cantidad de facturas impagadas: {{ dataCancellation.unpaidReceipts }}.
        </div>
        <div class="col-12 col-lg-12">
          Total de las facturas impagadas: {{ dataCancellation.amountUnpaid }}€.
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-lg-12">
          Es posible tener cargos adicionales en función del estado del
          terminal.
        </div>
      </div>
      <div class="h-100 d-flex justify-content-between mt-5">
        <div>
          <button
            class="btn generalSecondaryButton"
            @click="selectTab('content2')"
            :disabled="loading"
          >
            Atrás
          </button>
        </div>
        <div>
          <img
            v-if="loading"
            src="../../../../../assets/loaderPrimary.svg"
            height="40"
            alt=""
          />
          <button
            class="btn btn-primary generalPrimaryButton"
            v-if="!loading"
            @click="cancelledBO()"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
    <div v-if="content === 'content4'">
      <div class="row">
        <div class="col-12 col-lg-12">
          <div class="text-center">
            <div class="mb-3">
              <i class="fa fa-check-circle text-success" style="font-size: 3rem;"></i>
            </div>
            <h4 class="text-success">Operación realizada correctamente</h4>
            <p class="text-muted">El modal se cerrará automáticamente en {{ countdown }} segundos...</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="content === 'content5'">
      <div class="row">
        <div class="col-12 col-lg-12"><span class="generalTitleItemModal">Ha ocurrido un error:</span></div>
        <div class="col-12 col-lg-12 mt-4"><span class="text-danger">{{errorMessage}}</span></div>
      </div>
    </div>
    <div v-if="content === 'content6'">
      <div v-if="loading" class="row">
        <div class="col-12 col-lg-12 text-center">
          <img
            src="../../../../../assets/loaderPrimary.svg"
            height="130"
            alt=""
          />
        </div>
      </div>
      <div class="row" v-if="!loading">
        <div v-if="confirmTitle !== ''" class="col-12 col-lg-12"><span class="generalTitleItemModal">{{confirmTitle}}</span></div>
        <div class="col-12 col-lg-12 mt-4"><span>{{confirmMessage}}</span></div>
      </div>
      <div class="h-100 d-flex justify-content-between mt-5" v-if="!loading">
        <div>
          <button
            class="btn generalSecondaryButton"
            @click="selectTab('content1')"
          >
            Atrás
          </button>
        </div>
        <div>
          <button
            class="btn btn-primary generalPrimaryButton float-right mt-4"
            @click="cancelledBO()"
            v-if="!revision"
          >
            Confirmar
          </button>
          <button
            class="btn btn-primary generalPrimaryButton float-right mt-4"
            v-if="revision"
            @click="continuarRevision()"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
    <div v-if="content === 'content1'">
      <img
        v-if="loading"
        src="../../../../../assets/loaderPrimary.svg"
        height="40"
        alt=""
      />
      <button
        class="btn btn-primary generalPrimaryButton float-right"
        data-dismiss="modal"
        aria-label="Close"
        @click="cancelledBO()"
        :disabled="reason == ''"
        v-if="!loading && !revision && reasonConfirmationMessage.indexOf(reason) === -1"
      >
        Confirmar
      </button>
      <button
        class="btn btn-primary generalPrimaryButton float-right mt-4"
        v-if="revision && reasonConfirmationMessage.indexOf(reason) === -1"
        @click="continuarRevision()"
      >
        Continuar
      </button>
      <button
        class="btn btn-primary generalPrimaryButton float-right mt-4"
        v-if="reasonConfirmationMessage.indexOf(reason) !== -1"
        @click="continuarConConfirmacion()"
      >
        Continuar
      </button>
    </div>
    <button
      :id="id + 'CierreModal'"
      style="display: none"
      data-dismiss="modal"
    />
  </Modal>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import Modal from "../../../../Widgets/Shared/Modal.vue"
import provincias from "../../../../../data/provinces.json"
import { required, email, numeric, minLength } from "@vuelidate/validators"
import axios from "axios"
import VueNextSelect from "vue-next-select"
import moment from 'moment'

const addressCaracters = (value) => {
  if (/[$%&|<>#=¿?¡!@~¬/{}[-_()*+´¨`^¢,:;\]\\·"'€]/gi.test(value)) return false
  else return true
}

export default {
  name: "ConfirmCancellationBO",

  setup() {
    const v$ = useVuelidate()
    return { v$ }
  },
  props: [
    "id",
    "modalTitle",
    "class",
    "showFooter",
    "numContract",
    "contractStatus",
    "documentID",
    "storeNumber",
    "tracking",
    "endDate",
    "contractData"
  ],
  components: {
    Modal,
    VueNextSelect
  },
  data() {
    return {
      classes: this.class,
      reason: "",
      reasonsData: [],
      reasonsTraduction: [],
      revision: false,
      reasonRevision: [
        "CANCELADO POR BACKOFFICE",
        "CANCELADO POR IMPAGO",
        "CANCELADO POR DEVOLUCIÓN",
        "CANCELADO POR FRAUDE",
        "CANCELACION FRAUDE EN SEGURO",
      ],
      sequra: false,
      reasonSecura: ["RENOVACIÓN ANTICIPADA"],
      name: "",
      surname1: "",
      documentType: "",
      documentNumber: "",
      mobile: "",
      birthdate: "",
      email: "",
      streetType: "",
      street: "",
      number: "",
      floor: "",
      door: "",
      stair: "",
      postalCode: "",
      city: "",
      state: "",
      provincesData: provincias,
      tipoDireccion: ["Calle", "Avenida", "Plaza", "Carretera", "Travesía"],
      subClass: "overflowUnSet",
      content: "content1",
      loading: false,
      loadingDataCustomer: false,
      loadingDataContract: false,
      dataCancellation: {},
      backOfficeUser: this.$cookies.get("username"),
      errorMessage: '',
      reasonConfirmationMessage: [
        "TERMINADO Y COMPRA",
        "RENOVADO Y COMPRA",
        "RENOVADO AMPLIACIÓN Y COMPRA",
        "CANCELADO POR CLIENTE",
        "RENOVACIÓN ANTICIPADA",
        "DESISTIDO PTE DE RECEPCION",
        "DESISTIDO",
      ],
      confirmTitle: "",
      confirmMessage: "",
      countdown: 3,
      countdownInterval: null
    }
  },
  created() {
    console.log("Estado inicial del componente ConfirmCancellationBO:", this.contractData);

    let reasonsDataTemp = []
    let reasonsTraductionTemp = []
    let lastPaymentDate ='';
    const nowDate = moment();
    switch (this.contractStatus) {
      case "CONFIRMED":
        reasonsDataTemp = [
          "CANCELADO POR FRAUDE",
          "CANCELACION FRAUDE EN SEGURO",
          "CANCELADO POR DEVOLUCIÓN",
          "CANCELADO POR CLIENTE",
          "CANCELADO POR BACKOFFICE",
          "DESISTIDO PTE DE RECEPCION"
        ]
        reasonsTraductionTemp = [
          "CANCELED_FOR_FRAUD",
          "CANCELED_FOR_INSURANCE_FRAUD",
          "CANCELED_FOR_RETURN",
          "CANCELED_BY_CUSTOMER",
          "CANCELED_BY_BO",
          "DESISTED_PENDING_RECEIVE"
        ]
        
        lastPaymentDate = moment(this.endDate);
        if(lastPaymentDate.isValid()){
          // aparece si la fecha de hoy es mayor o igual que la fecha del ultimo pago 'endDate'
          if (nowDate >= lastPaymentDate) {
            reasonsDataTemp.push("TERMINADO Y COMPRA", "TERMINADO", "RENOVADO", "TERMINADO AMPLIACIÓN Y COMPRA", "RENOVADO AMPLIACIÓN Y COMPRA");
            reasonsTraductionTemp.push("FINISHED_AND_PURCHASE", "FINISHED", "RENOVATED", "FINISHED_EXPANSION_AND_PURCHASE", "RENOVATED_EXPANSION_AND_PURCHASE");
          }
          // aparece si la fecha de hoy es menor que la fecha del ultimo pago 'endDate'
          if (nowDate < lastPaymentDate) {
            reasonsDataTemp.push("RENOVACIÓN ANTICIPADA");
            reasonsTraductionTemp.push("EARLY_RENEWED");
          }
        }

        if (this.contractData.paidInstalments >= 24) {
          reasonsDataTemp.push("TERMINADO Y COMPRA", "TERMINADO", "RENOVADO Y COMPRA");
          reasonsTraductionTemp.push("FINISHED_AND_PURCHASE", "FINISHED", "RENOVATED_AND_PURCHASE");
        }


        break
      case "DESISTED_PENDING_RECEIVE":
        reasonsDataTemp = ["DESISTIDO"]
        reasonsTraductionTemp = ["DESISTED"]
        break
      case "UNPAID":
        reasonsDataTemp = ["CANCELADO POR IMPAGO", "CANCELADO POR IMPAGO +"]
        reasonsTraductionTemp = [
          "CANCELED_FOR_NON_PAYMENT",
          "CANCELED_FOR_UNPAID_PLUS"
        ]
        break
      default:
        reasonsDataTemp = ["CANCELADO POR BACKOFFICE"]
        reasonsTraductionTemp = ["CANCELED_BY_BO"]
        this.reason = "CANCELADO POR BACKOFFICE"
        break
    }
    this.reasonsData = reasonsDataTemp
    this.reasonsTraduction = reasonsTraductionTemp
  },
  watch: {
    reason() {
      if (this.reasonRevision.indexOf(this.reason) === -1) {
        this.revision = false
      }
      if (this.reasonSecura.indexOf(this.reason) === -1) {
        this.sequra = false
      }
    },
    content() {
      if (this.content === "content1") {
        this.subClass = "overflowUnSet"
      } else {
        this.subClass = "overflowAuto"
      }
    }
  },
  validations() {
    return {
      mobile: {
        required,
        numeric,
        minLength: minLength(9)
      },
      email: {
        required,
        email
      },
      streetType: {
        required
      },
      street: {
        required,
        addressCaracters
      },
      number: {
        required,
        addressCaracters
      },
      floor: {
        addressCaracters
      },
      door: {
        addressCaracters
      },
      stair: {
        addressCaracters
      },
      postalCode: {
        required
      },
      city: {
        required,
        addressCaracters
      },
      state: {
        required
      }
    }
  },
  beforeUnmount() {
    // Limpiar intervalo cuando se destruye el componente
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  },
  methods: {
    cancelledBO() {
      this.loading = true
      let statusAux =
        this.reasonsTraduction[this.reasonsData.indexOf(this.reason)]
      let bodyToSend = {
        status: statusAux
      }
      if (this.$store.state.roles.Backoffice_member_empresas) {
        axios
          .patch(
            `/contract/business/update-status/${this.numContract}`,
            bodyToSend
          )
          .then(() => {
            // Emitir solo señal de éxito sin el estado para evitar actualización optimista
            this.$emit("refreshCancellationBOList", {
              success: true,
              contractId: this.numContract,
              needsRefresh: true
            })
            this.loading = false
            this.revision = false
            this.selectTab("content4")
          })
          .catch((error) => {
            console.error('Error en cancelación (empresas):', error);
            this.loading = false;
            this.selectTab("content5");
            this.errorMessage = error.response?.data?.message || error.message || 'Error desconocido en cancelación'
          });
      } else {
        if (this.revision) {
          let bodyToSendUpdate = {
            email: this.email || "",
            mobile: this.mobile || "",
            telephone: "",
            trustworthy: false,
            billingAddress: {
              street: this.street || "",
              number: this.number || "",
              postalCode: this.postalCode || "",
              city: this.city || "",
              province: this.state || "",
              streetType: this.streetType || "",
              floor: this.floor || "",
              door: this.door || "",
              stair: this.stair || ""
            },
            deliveryAddress: {
              street: this.street || "",
              number: this.number || "",
              postalCode: this.postalCode || "",
              city: this.city || "",
              province: this.state || "",
              streetType: this.streetType || "",
              floor: this.floor || "",
              door: this.door || "",
              stair: this.stair || ""
            }
          }
          axios
            .patch(
              `/customer/contact-info-by-legal-identifier/${this.documentNumber}`,
              bodyToSendUpdate
            )
            .then(() => {
              let bodyToCancel = {
                contractId: this.numContract,
                deliveryDate: "2000-01-01",
                storeNumber: this.storeNumber,
                tracking: this.tracking
              }
              axios
                .post(`contract/flow/request/cancellation`, bodyToCancel)
                .then(() => {
                  // Emitir señal de éxito para el flujo con revisión
                  this.$emit("refreshCancellationBOList", {
                    success: true,
                    contractId: this.numContract,
                    needsRefresh: true
                  })
                  this.loading = false
                  this.revision = false
                  this.selectTab("content4")
                })
                .catch((error) => {
                  console.error('Error en solicitud de cancelación:', error);
                  this.loading = false
                  this.selectTab("content5")
                  this.errorMessage = error.response?.data?.message || error.message || 'Error en la solicitud de cancelación'
                });
            })
            .catch((error) => {
              console.error('Error en actualización de cliente:', error);
              this.loading = false
              this.selectTab("content5")
              this.errorMessage = error.response?.data?.message || error.message || 'Error al actualizar datos del cliente'
            });
        } else if (this.sequra) {
          axios
            .post(`/contract-renewal/order`, {
              parentContractId: this.numContract,
              backOfficeUser: this.backOfficeUser,
              isLegacy: true
            })
            .then(() => {
              // Emitir señal de éxito para el flujo Sequra
              this.$emit("refreshCancellationBOList", {
                success: true,
                contractId: this.numContract,
                needsRefresh: true
              })
              this.sequra = false
              this.loading = false
              this.revision = false
              this.selectTab("content4")
            })
            .catch((error) => {
              console.error('Error en renovación Sequra:', error);
              this.loading = false
              this.selectTab("content5")
              this.errorMessage = error.response?.data?.message || error.message || 'Error en renovación Sequra'
            });
        } else {
          axios
            .patch(`/contract/update-status/${this.numContract}`, bodyToSend)
            .then(() => {
              // Emitir solo señal de éxito sin el estado para evitar actualización optimista
              this.$emit("refreshCancellationBOList", {
                success: true,
                contractId: this.numContract,
                needsRefresh: true
              })
              this.loading = false
              this.revision = false
              this.selectTab("content4")
            })
            .catch((error) => {
              console.error('Error en cancelación estándar:', error);
              this.loading = false
              this.selectTab("content5")
              this.errorMessage = error.response?.data?.message || error.message || 'Error en cancelación estándar'
            });
        }
      }
    },
    selectTab(id) {
      // Limpiar intervalo anterior si existe
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }

      this.content = id

      // Si se muestra el éxito (content4), iniciar cuenta regresiva
      if (id === 'content4') {
        this.countdown = 3;
        this.countdownInterval = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
            this.onClose();
          }
        }, 1000);
      }
    },
    continuarRevision() {
      this.content = "content2"
      if (this.documentID !== "" && this.numContract !== "") {
        this.loadingDataCustomer = true
        this.loadingDataContract = true
        axios.get(`/customer/${this.documentID}`).then((response) => {
          this.name = response.data.name
          this.surname1 = response.data.surnames
          this.documentType = response.data.documentType || "DNI"
          this.documentNumber = response.data.legalIdentifier
          this.mobile = response.data.mobile
          this.birthdate = response.data.birthdate
          this.email = response.data.email
          this.loadingDataCustomer = false
        })
        .catch((error) => {
          console.error('Error al cargar datos del cliente:', error);
          this.loadingDataCustomer = false
          this.selectTab("content5")
          this.errorMessage = error.response?.data?.message || error.message || 'Error al cargar datos del cliente'
        });
        axios.get(`/contract/${this.numContract}`).then((response) => {
          this.streetType = response.data.deliveryAddress.streetType || "Calle"
          this.street = response.data.deliveryAddress.street
          this.number = response.data.deliveryAddress.number
          this.floor = response.data.deliveryAddress.floor
          this.door = response.data.deliveryAddress.door
          this.stair = response.data.deliveryAddress.stair
          this.postalCode = response.data.deliveryAddress.postalCode
          this.city = response.data.deliveryAddress.city
          this.state = response.data.deliveryAddress.province
          this.loadingDataContract = false
        })
        .catch((error) => {
          console.error('Error al cargar datos del contrato:', error);
          this.loadingDataContract = false
          this.selectTab("content5")
          this.errorMessage = error.response?.data?.message || error.message || 'Error al cargar datos del contrato'
        });
        axios
          .get(`/contract/request/cancellation/${this.numContract}`)
          .then((response) => {
            this.dataCancellation = response.data
          })
          .catch((error) => {
            console.error('Error al cargar datos de cancelación:', error);
            this.selectTab("content5")
            this.errorMessage = error.response?.data?.message || error.message || 'Error al cargar datos de cancelación'
          });
      }
    },
    continuarConConfirmacion() {
      this.confirmTitle = "";
      this.confirmMessage = "";
      switch (this.reason) {
        case "TERMINADO Y COMPRA":
        case "RENOVADO Y COMPRA":
        case "RENOVADO AMPLIACIÓN Y COMPRA":
          this.confirmTitle = "Esta operación implica cargos en la tarjeta del cliente.";
          this.confirmMessage = "¿Seguro qué el cliente quiere realizar la compra del terminal?";
          break
        case "CANCELADO POR CLIENTE":
          this.confirmTitle = "Esta operación implica cargos en la tarjeta del cliente.";
          this.confirmMessage = "¿Seguro qué el cliente quiere cancelar el contrato?";
          break
        case "RENOVACIÓN ANTICIPADA":
          this.confirmTitle = "Esta operación implica cargos en la tarjeta del cliente.";
          this.confirmMessage = "¿Seguro qué el cliente quiere renovar anticipadamente el contrato?";
          break
        case "DESISTIDO PTE DE RECEPCION":
        case "DESISTIDO":
          this.confirmMessage = "¿Seguro qué el cliente quiere desistir el contrato?";
          break
      }
      this.content = "content6";
    },
    onClose() {
      // Limpiar intervalo si existe
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }

      document.querySelector(`#${this.id}CierreModal`).click()
      this.$emit("closeModal", "")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#modalCancellationBO {
  .modal-content {
    overflow: unset;
    .vue-select {
      z-index: 9999;
    }
  }
  .overflowUnSet {
    .modal-content {
      overflow: unset;
    }
  }
  .overflowAuto {
    .modal-content {
      overflow: auto;
    }
  }
}
</style>
<style scoped></style>
